module.exports = __webpack_public_path__ + "72fa2abbde1a03bf9cb071e5ee921252.svg";